module.exports = __webpack_public_path__ + "static/media/p17.06b69891.png";